
import { iGamMarkingModel } from '@/interface/game-discussion-manage';
import { Component, Vue } from 'vue-property-decorator';
import Gamediscussion from './game-discussion/index.vue';
import GameMaking from './game-marking/index.vue';
import GameSearch from './game-search/index.vue';
@Component({
  components: { GameMaking, Gamediscussion, GameSearch },
})
export default class extends Vue {
  dynamComp = 'GameMaking';
  searchData: object = {};
  detail: iGamMarkingModel = {
    game_id: 0,
    game_name: '',
    score: 0,
    num_of_discussion: 0,
  };
  goDiscussion(row: iGamMarkingModel) {
    this.dynamComp = 'Gamediscussion';
    this.detail = row;
  }
  goBackMarking() {
    this.dynamComp = 'GameMaking';
  }
  goSearch(search: object) {
    this.dynamComp = 'GameSearch';
    this.searchData = search;
  }
}
